// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rqnttpMGVUTPGmW0 {
	display: flex;
	align-items: center;
	background-color: var(--lok-color-background-surface-fore);
	border-radius: var(--lok-radius-tag);
	padding: var(--lok-spacing-1) var(--lok-spacing-2);
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/Cards/components/CardModel/CardModel.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,0DAA0D;CAC1D,oCAAoC;CACpC,kDAAkD;AACnD","sourcesContent":[".container {\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: var(--lok-color-background-surface-fore);\n\tborder-radius: var(--lok-radius-tag);\n\tpadding: var(--lok-spacing-1) var(--lok-spacing-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `rqnttpMGVUTPGmW0`
};
export default ___CSS_LOADER_EXPORT___;
